import { render, staticRenderFns } from "./AmpliarFoto.vue?vue&type=template&id=89b98ae0&scoped=true"
import script from "./AmpliarFoto.vue?vue&type=script&lang=js"
export * from "./AmpliarFoto.vue?vue&type=script&lang=js"
import style0 from "./AmpliarFoto.vue?vue&type=style&index=0&id=89b98ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b98ae0",
  null
  
)

export default component.exports